import { render, staticRenderFns } from "./InventoryOutOfStockReport.vue?vue&type=template&id=80ace5ec&scoped=true"
import script from "./InventoryOutOfStockReport.vue?vue&type=script&lang=js"
export * from "./InventoryOutOfStockReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryOutOfStockReport.vue?vue&type=style&index=0&id=80ace5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ace5ec",
  null
  
)

export default component.exports